/** Mirrors the h3-0 contract's serviceStatus enum (dienststatus vocabulary). */
export const SERVICE_STATUSES = [
  'open', 'requested', 'expected', 'received', 'readyforprocessing',
  'processed', 'validated', 'delivered', 'onhold', 'canceled', 'closed',
] as const;
